"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontStyle;
(function (FontStyle) {
    FontStyle["REGULAR"] = "REGULAR";
    FontStyle["ITALIC"] = "ITALIC";
    FontStyle["BOLD"] = "BOLD";
    FontStyle["BOLD_ITALIC"] = "BOLD_ITALIC";
})(FontStyle = exports.FontStyle || (exports.FontStyle = {}));
var FontFormat;
(function (FontFormat) {
    FontFormat["TTF"] = "TTF";
})(FontFormat = exports.FontFormat || (exports.FontFormat = {}));
//# sourceMappingURL=Font.js.map